import * as React from 'react'
import type { ToolBarItemProps } from './ToolBar.types'
import { cn } from '@core/utils'

const ToolBarRight: React.FC<ToolBarItemProps> = ({ className, ...props }) => {
  return <div className={cn('max-w-[50%]', className)} {...props} />
}
export default ToolBarRight
